<template>
	<div class="container-xl">
		<main class="py-4">
	        <validation-observer ref="observer" v-slot="{ handleSubmit }">
	            <form @submit.prevent="handleSubmit(updateForm);">
					<div class="row g-3 mb-4 align-items-center justify-content-between">
						<div class="col-auto">
							<h1 class="app-page-title mb-0">{{ filledQuestionnaire.title }}</h1>
						</div>
						<div class="col-auto">
							<div class="page-utilities">
								<div class="row g-2 justify-content-start justify-content-md-end align-items-center">
									<div class="col-auto">
                                        <button type="button" class="btn btn-outline-success" v-on:click="isEdit = !isEdit">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="1.5em" height="1.5em" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                                <path stroke-linecap="round" stroke-linejoin="round" d="M8 7H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-3m-1 4l-3 3m0 0l-3-3m3 3V4" />
                                            </svg>
                                            {{ !isEdit ? __('form.form-edit') : __('form.form-view')}}
                                        </button>
										<button v-if="isEdit" type="submit" class="btn btn-outline-success">
											<svg xmlns="http://www.w3.org/2000/svg" width="1.5em" height="1.5em" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
												<path stroke-linecap="round" stroke-linejoin="round" d="M8 7H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-3m-1 4l-3 3m0 0l-3-3m3 3V4" />
											</svg>
											{{ __('form.form-save') }}
										</button>
                                        <a v-else class="btn btn-sm btn-outline-success" download="true" @click.prevent="download('/get-form-pdf/' + filledQuestionnaire.id + filledQuestionnaire.slug)">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="1.5em" height="1.5em" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                                <path stroke-linecap="round" stroke-linejoin="round" d="M8 7H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-3m-1 4l-3 3m0 0l-3-3m3 3V4" />
                                            </svg>
                                            PDF ({{ filledQuestionnaire.downloads }}x gedownload)
                                        </a>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-md-12">
                            <div class="card mb-3">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-md-3">
                                            <validation-provider v-slot="{ errors }" class="mb-3" name="Bedrijfsnaam" tag="div">
                                                <label for="company_name" class="form-label">Bedrijfsnaam</label>
                                                <input :disabled="!isEdit" :class="{'is-invalid': errors.length}" type="text" class="form-control" id="company_name" v-model="filledQuestionnaire.company_name">
                                                <span v-if="errors.length" class="invalid-feedback d-block">{{ errors[0] }}</span>
                                            </validation-provider>
                                        </div>
                                        <div class="col-md-3">
		                                    <validation-provider v-slot="{ errors }" class="mb-3" name="Plannummer" tag="div">
												<label for="project_code" class="form-label">Plannummer</label>
												<input :disabled="!isEdit" :class="{'is-invalid': errors.length}" type="text" class="form-control" id="project_code" v-model="filledQuestionnaire.project_code">
		                                        <span v-if="errors.length" class="invalid-feedback d-block">{{ errors[0] }}</span>
		                                    </validation-provider>
										</div>
                                        <div class="col-md-6">
                                            <validation-provider v-slot="{ errors }" class="mb-3" name="Locatie" rules="required" tag="div">
                                                <label for="location" class="form-label">Locatie</label>
                                                <input :disabled="!isEdit" :class="{'is-invalid': errors.length}" type="text" class="form-control" id="location" v-model="filledQuestionnaire.location">
                                                <span v-if="errors.length" class="invalid-feedback d-block">{{ errors[0] }}</span>
                                            </validation-provider>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <validation-provider v-slot="{ errors }" class="mb-3" name="Naam cursist" rules="required" tag="div">
                                                <label for="student_name" class="form-label">Naam cursist</label>
                                                <input :disabled="!isEdit" :class="{'is-invalid': errors.length}" type="text" class="form-control" id="student_name" v-model="filledQuestionnaire.participant_name">
                                                <span v-if="errors.length" class="invalid-feedback d-block">{{ errors[0] }}</span>
                                            </validation-provider>
                                        </div>

                                        <div class="col-md-3">
                                            <validation-provider rules="required" name="Geldig rijbewijs" v-slot="{ errors }" tag="div">
                                                <label class="form-label">Geldig rijbewijs</label>
                                                <div class="form-check" v-for="option in validDriverLicenseOptions" :key="option.body">
                                                    <input :disabled="!isEdit" :class="{'is-invalid': errors.length}" class="form-check-input" type="radio" name="driving-licence" :value="option.value" v-model="filledQuestionnaire.has_valid_driver_license" :id=option.name>
                                                    <label class="form-check-label" :for=option.name>
                                                        {{ option.name }}
                                                    </label>
                                                </div>
                                                <span v-if="errors.length" class="invalid-feedback d-block">{{ errors[0] }}</span>
                                            </validation-provider>
                                        </div>
                                        <div class="col-md-3">
											<validation-provider rules="required" name="Is aanwezig" v-slot="{ errors }" tag="div">
                                                <label class="form-label">Aanwezig?</label>
                                                <div class="form-check">
                                                    <input :disabled="!isEdit" :class="{'is-invalid': errors.length}" class="form-check-input" type="radio" name="is-present" :value="1" v-model="filledQuestionnaire.was_present" id="was_present1">
                                                    <label class="form-check-label" for="was_present1">
                                                        {{ __('questionnaires.q-boolean-yes') }}
                                                    </label>
                                                </div>
                                                <div class="form-check">
                                                    <input :disabled="!isEdit" :class="{'is-invalid': errors.length}" class="form-check-input" type="radio" name="is-present" :value="0" v-model="filledQuestionnaire.was_present" id="was_present2">
                                                    <label class="form-check-label" for="was_present2">
                                                        {{ __('questionnaires.q-boolean-no') }}
                                                    </label>
                                                </div>
                                                <span v-if="errors.length" class="invalid-feedback d-block">{{ errors[0] }}</span>
                                            </validation-provider>
										</div>

                                    </div>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <validation-provider v-slot="{ errors }" class="mb-3" name="datum" rules="required" tag="div">
                                                <label for="date" class="form-label">Datum</label>
                                                <input :disabled="!isEdit" :class="{'is-invalid': errors.length}" type="date" class="form-control" id="date" v-model="filledQuestionnaire.date">
                                                <span v-if="errors.length" class="invalid-feedback d-block">{{ errors[0] }}</span>
                                            </validation-provider>
                                        </div>
                                        <div class="col-md-3">
                                            <validation-provider v-slot="{ errors }" class="mb-3" name="Starttijd" rules="required" tag="div">
                                                <label for="start_time" class="form-label">Starttijd</label>
                                                <input :disabled="!isEdit" :class="{'is-invalid': errors.length}"  type="time" class="form-control" id="start_time" v-model="filledQuestionnaire.session_start">
                                                <span v-if="errors.length" class="invalid-feedback d-block">{{ errors[0] }}</span>
                                            </validation-provider>
                                        </div>
                                        <div class="col-md-3">
                                            <validation-provider v-slot="{ errors }" class="mb-3" name="Eindtijd" rules="required" tag="div">
                                                <label for="end_time" class="form-label">Eindtijd</label>
                                                <input :disabled="!isEdit" :class="{'is-invalid': errors.length}"  type="time" class="form-control" id="end_time" v-model="filledQuestionnaire.session_end">
                                                <span v-if="errors.length" class="invalid-feedback d-block">{{ errors[0] }}</span>
                                            </validation-provider>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <validation-provider v-slot="{ errors }" class="mb-3" name="E-mailadres cursist" tag="div">
												<label for="date" class="form-label">E-mail cursist</label>
												<input :disabled="!isEdit" :class="{'is-invalid': errors.length}" type="text" class="form-control" v-model="filledQuestionnaire.participant_email">
		                                        <span v-if="errors.length" class="invalid-feedback d-block">{{ errors[0] }}</span>
		                                    </validation-provider>
                                        </div>
                                        <div class="col-md-6">
		                                    <validation-provider v-slot="{ errors }" class="mb-3" name="Telefoonnummer cursist" tag="div">
												<label for="date" class="form-label">Telefoonnummer cursist</label>
												<input :disabled="!isEdit" :class="{'is-invalid': errors.length}" type="text" class="form-control" v-model="filledQuestionnaire.participant_phone">
		                                        <span v-if="errors.length" class="invalid-feedback d-block">{{ errors[0] }}</span>
		                                    </validation-provider>
										</div>
                                    </div>
                                </div>
                            </div>
                            <div v-for="section in filledQuestionnaire.answers" :key="section.id">
                                <div class="mb-3">
								    <h5 class="fw-bolder">{{ section.title }} <span class="section-score" v-if="section.averageScore > 0">({{ section.averageScore }})</span></h5>
							    </div>

                                <div v-for="(question) in section.questions" :key="question.id">
                                    <div v-if="question.type === 'BOOLEAN'" class="mb-3">
                                        <div class="card">
                                            <div class="card-body">
                                                <validation-provider :rules="question.required && filledQuestionnaire.was_present ? 'required': ''" :name="question.body" v-slot="{ errors }" tag="div">
                                                    <p class="fw-bolder">{{ question.body }}</p>
                                                    <div class="form-check" v-for="option in question.options" :key="option.body">
                                                        <input :disabled="!isEdit" class="form-check-input" :value="option.body" type="radio" :name="question.id" v-model="question.answer" :id="question.id + option.sequence">
                                                        <label class="form-check-label" :for="question.id + option.sequence">
                                                            {{ option.body }}
                                                        </label>
                                                    </div>
                                                    <span v-if="errors.length" class="invalid-feedback d-block">{{ errors[0] }}</span>
                                                </validation-provider>
                                            </div>
                                        </div>
                                    </div>

                                    <div v-if="question.type === 'SINGLE_CHOICE' || question.type === '3_POINT_GRADING_SCALE' || question.type === '4_POINT_GRADING_SCALE'" class="mb-3">
                                        <div class="card">
                                            <div class="card-body">
                                                <validation-provider :rules="question.required && filledQuestionnaire.was_present ? 'required': ''" :name="question.body" v-slot="{ errors }" tag="div">
                                                    <span class="fw-bolder question-title" v-if="question.showNa" style="float:left;">{{ question.body }}</span>
                                                    <span class="fw-bolder question-title" v-else>{{ question.body }}</span>
                                                    <div class="form-check" v-if="question.showNa">
														<input :disabled="!isEdit" class="form-check-input option-na-input" type="radio" value="0" @change="calculateScoreHandler" v-model="question.answer" :name="question.id" :id="question.id + '_NA'">
														<label class="form-check-label option-na-label" :for="question.id + '_NA'">
															{{ __('questionnaires.question-option-na') }}
														</label>
													</div>
                                                    <div class="form-check" v-for="option in question.options" :key="option.body">
                                                        <input :disabled="!isEdit" class="form-check-input" type="radio" :value="option.body" @change="calculateScoreHandler" v-model="question.answer" :name="question.id" :id="question.id + option.sequence">
                                                        <label class="form-check-label" :for="question.id + option.sequence">
                                                            {{ option.body }}
                                                        </label>
                                                    </div>
                                                    <span v-if="errors.length" class="invalid-feedback d-block">{{ errors[0] }}</span>
                                                </validation-provider>
                                            </div>
                                        </div>
                                    </div>

                                    <div v-if="question.type === 'MULTI_CHOICE'" class="mb-3">
                                        <div class="card">
                                            <div class="card-body">
                                                <validation-provider :rules="question.required && filledQuestionnaire.was_present ? 'required': ''" :name="question.body" v-slot="{ errors }" tag="div">
                                                    <p class="fw-bolder">{{ question.body }}</p>
                                                    <div class="form-check" v-for="option in question.options" :key="option.body">
                                                        <input :disabled="!isEdit" class="form-check-input" type="checkbox" :value="option.body" v-model="question.answer" :id="question.id + '-' + option.sequence">
                                                        <label class="form-check-label" :for="question.id + '-' + option.sequence">
                                                            {{ option.body }}
                                                        </label>
                                                    </div>
                                                    <span v-if="errors.length" class="invalid-feedback d-block">{{ errors[0] }}</span>
                                                </validation-provider>
                                            </div>
                                        </div>
                                    </div>

                                    <div v-if="question.type === 'TEXT'" class="mb-3">
                                        <div class="card">
                                            <div class="card-body">
                                                <validation-provider :rules="question.required && filledQuestionnaire.was_present ? 'required': ''" :name="question.body" v-slot="{ errors }" tag="div">
                                                    <p class="fw-bolder">{{ question.body }}</p>
                                                    <textarea :disabled="!isEdit" :class="{'is-invalid': errors.length}" v-model="question.answer"  class="form-control" rows="5"></textarea>
                                                    <span v-if="errors.length" class="invalid-feedback d-block">{{ errors[0] }}</span>
                                                </validation-provider>
                                            </div>
                                        </div>
                                    </div>

                                    <div v-if="question.type === 'NUMBER'" class="mb-3">
                                        <div class="card">
                                            <div class="card-body">
                                                <validation-provider :rules="question.required && filledQuestionnaire.was_present ? 'required': ''" :name="question.body" v-slot="{ errors }" tag="div">
                                                    <p class="fw-bolder">{{ question.body }}</p>
                                                    <div class="row">
                                                        <div class="col-md-4">
                                                            <input :disabled="!isEdit" :class="{'is-invalid': errors.length}" v-model="question.answer" type="number" class="form-control">
                                                        </div>
                                                    </div>
                                                    <span v-if="errors.length" class="invalid-feedback d-block">{{ errors[0] }}</span>
                                                </validation-provider>
                                            </div>
                                        </div>
                                    </div>

                                    <div v-if="question.type === 'DATE'" class="mb-3">
                                        <div class="card">
                                            <div class="card-body">
                                                <validation-provider :rules="question.required && filledQuestionnaire.was_present ? 'required': ''" :name="question.body" v-slot="{ errors }" tag="div">
                                                    <p class="fw-bolder">{{ question.body }}</p>
                                                    <div class="row">
                                                        <div class="col-md-4">
                                                            <input :disabled="!isEdit" :class="{'is-invalid': errors.length}" v-model="question.answer" type="date" class="form-control">
                                                        </div>
                                                    </div>
                                                    <span v-if="errors.length" class="invalid-feedback d-block">{{ errors[0] }}</span>
                                                </validation-provider>
                                            </div>
                                        </div>
                                    </div>

                                    <div v-if="question.type === 'TIME'" class="mb-3">
                                        <div class="card">
                                            <div class="card-body">
                                                <validation-provider :rules="question.required && filledQuestionnaire.was_present ? 'required': ''" :name="question.body" v-slot="{ errors }" tag="div">
                                                    <p class="fw-bolder">{{ question.body }}</p>
                                                    <div class="row">
                                                        <div class="col-md-4">
                                                            <input :disabled="!isEdit" :class="{'is-invalid': errors.length}" v-model="question.answer" type="time" class="form-control">
                                                        </div>
                                                    </div>
                                                    <span v-if="errors.length" class="invalid-feedback d-block">{{ errors[0] }}</span>
                                                </validation-provider>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
						</div>
					</div>

                    <div v-if="filledQuestionnaire.has_passed !== null && filledQuestionnaire.was_present" class="col-md-12">
                        <div class="mb-3">
                            <hr v-if="filledQuestionnaire.totalAverageScore > 0" :class="filledQuestionnaire.totalAverageScore > 5.5 ? 'bar-score-positive' : 'bar-score-negative'"></hr>
                            <h5 class="fw-bolder">{{ __('questionnaires.final-verdict-section-title') }}</span></h5>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="mb-3">
                                    <div class="card">
                                        <div class="card-body">
                                            <validation-provider rules="required" name="Eindbeoordeling" v-slot="{ errors }" tag="div">
                                                <p class="fw-bolder">{{ __('questionnaires.final-verdict-text') }}</p>
                                                <div class="form-check">
                                                    <input :disabled="!isEdit" :class="{'is-invalid': errors.length}" class="form-check-input" type="radio" name="has_passed" :value="1" v-model="filledQuestionnaire.has_passed" id="has-passed-true">
                                                    <label class="form-check-label" for="has-passed-true">
                                                        {{ __('questionnaires.q-boolean-yes') }}
                                                    </label>
                                                </div>
                                                <div class="form-check">
                                                    <input :disabled="!isEdit" :class="{'is-invalid': errors.length}" class="form-check-input" type="radio" name="has_passed" :value="0" v-model="filledQuestionnaire.has_passed" id="has-passed-false">
                                                    <label class="form-check-label" for="has-passed-false">
                                                        {{ __('questionnaires.q-boolean-no') }}
                                                    </label>
                                                </div>
                                                <span v-if="errors.length" class="invalid-feedback d-block">{{ errors[0] }}</span>
                                            </validation-provider>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

		            <div class="row">
			            <div class="col-md-6">
				            <p class="fw-bolder">{{ __('form.signature-instructor') }}</p>
                            <div class="card">
                                <div class="card-body">
                                    <img :src="filledQuestionnaire.instructor_signature" style="min-height: 200px; max-height:280px; width: 100%">
                                </div>
                            </div>
			            </div>
			            <div class="col-md-6">
				            <p class="fw-bolder">{{ __('form.signature-participant') }}</p>
                            <div class="card">
                                <div class="card-body">
                                    <img :src="filledQuestionnaire.participant_signature" style="min-height: 200px;  max-height:280px; width: 100%">
                                </div>
                            </div>
			            </div>
		            </div>
		            <div class="row mt-5 g-2 justify-content-start justify-content-md-end align-items-center">
			            <div class="col-auto">
				            <button type="submit" class="btn btn-outline-success" v-if="isEdit">
					            <svg xmlns="http://www.w3.org/2000/svg" width="1.5em" height="1.5em" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
						            <path stroke-linecap="round" stroke-linejoin="round" d="M8 7H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-3m-1 4l-3 3m0 0l-3-3m3 3V4" />
					            </svg>
					            {{ __('form.form-save') }}
				            </button>
			            </div>
		            </div>
	            </form>
	        </validation-observer>
		</main>
	</div>
</template>

<script>

import moment from "moment";

export default {
	props: {
		questionnaireProp: {
			type: Object,
			required: true,
		},
	},

	data() {
		return {
			filledQuestionnaire: this.questionnaireProp,
            validDriverLicenseOptions : {
                1 : {
                    name: 'Ja',
                    value: 1,
                },
                2 : {
                    name: 'Nee',
                    value: 0,
                }
            },
			loading: false,
            isEdit: false
		}
	},

    created(){
        this.calculateScoreHandler()
    },

	methods: {
        download (path) {
            window.open(path, "_self");
            setTimeout(() =>  document.location.reload(true), 7500);
        },

        calculateScoreHandler: function(){

            Array.from(this.filledQuestionnaire.answers).forEach(section => {

            let eligibleQuestionCount = 0;
            let filledQuestionCount = 0;
            let sectionTotal = 0;
            let sectionDontShowCounter = 0;

            Array.from(section.questions).forEach((answer, index) => {

                if (answer['type'] === '3_POINT_GRADING_SCALE' || answer['type'] === '4_POINT_GRADING_SCALE') {
                    eligibleQuestionCount++

                    Array.from(answer.options).forEach(option => {
                        if (option['body'] === answer['answer']) {

                            filledQuestionCount++
                            sectionTotal = sectionTotal + option['attribute'];
                        }
                    })

                    if (answer['answer'] == '' || answer['answer'] == null){
                        sectionDontShowCounter++
                    }
                }

                if (eligibleQuestionCount > 0 && sectionDontShowCounter == 0) {
                    section.averageScore = (sectionTotal / filledQuestionCount).toFixed(1);

                }
                else{
                    //looks like a fuzzy else,
                    //but is necessary to prevent showing the averageScore too early
                    section.averageScore = '';
                }
            })
        })

        let subTotal = 0;
        let eligibleSectionCount = 0;

        //loop again, to get every set sectionAverage
        Array.from(this.filledQuestionnaire.answers).forEach(section => {

            if (section.averageScore > 0)
            {
                subTotal += parseFloat(section.averageScore);
                eligibleSectionCount++;
            }

        })
        this.filledQuestionnaire.totalAverageScore = (subTotal / eligibleSectionCount).toFixed(1);
        },

        updateForm: async function () {

            const isValid = await this.$refs.observer.validate();

            if (!isValid)
            {
                const el = document.querySelector(".invalid-feedback"); //select first validation error
                el.scrollIntoView({block: "center"});

                return
            }

            this.loading = true

            if (this.filledQuestionnaire.has_passed === undefined){
                this.filledQuestionnaire.has_passed = null;
                this.filledQuestionnaire.totalAverageScore = 0;
            }

            axios.put('/forms/'+ this.filledQuestionnaire.id, this.filledQuestionnaire).then(response => {
                Toast.fire({icon: 'success', title: response.data.message})
                this.loading = false
            }).catch(error => {
                console.log(error);
            });
        },
	}
}
</script>


<style scoped lang="scss">
$color-primary: #fff;
$color-secondary: #eaf0f4;
$color-blue: #4c8ce4;
$color-orange: #ff9635;
$color-red: #f06559;
$color-green: #48bf7a;

.color-blue {
    color: $color-blue;
}

.color-orange {
    color: $color-orange;
}

.color-red {
    color: $color-red;
}

.color-green {
    color: $color-green;
}
.float-left {
    float: left;
}

.float-right {
    float: right;
}

.text-right {
    text-align: right;
}

.width-10 {
    width: 10% !important;
    display: inline-block;
}

.vsb-btn-link {
    border: none;
    background: none;
    padding: 5px;
}
#participantSignature, #instructorSignature {
	border: double 3px transparent;
	border-radius: 5px;
	background-image: linear-gradient(white, white),
	linear-gradient(white, white);
	background-origin: border-box;
	background-clip: content-box, border-box;
}

.bar-score-negative {
	border: 0;
    height: 5px !important;
    background-image: linear-gradient(to right, rgba(255, 0, 0, 1.0), rgba(255, 0, 0, 0.85), rgba(255, 0, 0, 1.0));
}

.bar-score-positive {
	border: 0;
    height: 5px !important;
    background-image: linear-gradient(to right, rgba(0, 255, 0, 1.0), rgba(0, 255, 0, 0.85), rgba(0, 255, 0, 1.0));
}

.option-na-input{
    margin-left:10px !important;
}

.option-na-label{
    margin-left:5px;
    font-style: italic;
}
</style>
